import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-screen flex flex-col justify-center pt-20 pb-16 px-6 md:px-10">
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div
          className="absolute inset-0 opacity-[0.06]"
          style={{
            backgroundImage: `url(https://readdy.ai/api/search-image?query=Delicate%20abstract%20geometric%20pattern%20with%20soft%20flowing%20lines%20on%20warm%20cream%20backdrop%2C%20subtle%20textile%20weave%20texture%2C%20minimalist%20Scandinavian%20design%2C%20gentle%20organic%20shapes%2C%20very%20light%20airy%20composition%2C%20barely%20visible%20neutral%20pattern&width=1600&height=1200&seq=bg-texture-v2&orientation=landscape)`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
        />
      </div>

      <div className="relative z-10 max-w-[1440px] mx-auto w-full">
        <div className="flex flex-col lg:flex-row items-start gap-10 lg:gap-16">
          <div className="flex-1 pt-8 lg:pt-16">
            <h1 className="font-heading text-5xl md:text-6xl lg:text-7xl font-extrabold text-foreground-950 leading-[1.05] tracking-tight">
              Itaobuy<br />
              <span className="text-primary-500">Spreadsheet</span><br />
              Italia
            </h1>
          </div>

          <div className="flex-1 flex flex-col justify-end pt-4 lg:pt-24">
            <p className="text-base md:text-lg text-foreground-600 leading-relaxed max-w-lg mb-6">
              La risorsa italiana più completa per conoscere, analizzare e utilizzare Itaobuy Spreadsheet. 
              Guide dettagliate, confronti trasparenti e analisi di sicurezza per acquisti online più intelligenti.
            </p>
            <Link
              to="/articolo/"
              className="inline-flex items-center gap-2 text-primary-500 font-semibold text-sm hover:text-primary-600 transition-colors group whitespace-nowrap"
            >
              Esplora la guida completa
              <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
            </Link>
          </div>
        </div>

        <div className="mt-10 md:mt-14">
          <div className="relative w-full h-[320px] md:h-[420px] rounded-2xl overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Editorial%20fashion%20flatlay%20composition%20featuring%20curated%20selection%20of%20premium%20sneakers%2C%20tailored%20jacket%2C%20linen%20shirt%2C%20leather%20bag%20and%20minimal%20accessories%20arranged%20harmoniously%20on%20warm%20sand%20colored%20surface%2C%20soft%20directional%20sunlight%2C%20sophisticated%20Italian%20lifestyle%20aesthetic%2C%20high-end%20commercial%20catalog%20photography%2C%20clean%20organized%20layout%20with%20intentional%20spacing&width=1400&height=600&seq=hero-flatlay-v2&orientation=landscape"
              alt="Itaobuy Spreadsheet prodotti moda"
              title="Itaobuy Spreadsheet - Collezione Prodotti"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>

        <div className="mt-8 flex flex-wrap gap-2 md:gap-3">
          {categories.slice(0, 8).map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center px-3 py-1.5 rounded-full bg-background-100 text-foreground-600 text-xs font-medium hover:bg-accent-100 hover:text-accent-800 transition-colors whitespace-nowrap cursor-pointer"
            >
              {cat.name}
            </a>
          ))}
          <a
            href={categories[8].url}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center px-3 py-1.5 rounded-full bg-background-100 text-foreground-600 text-xs font-medium hover:bg-accent-100 hover:text-accent-800 transition-colors whitespace-nowrap cursor-pointer"
          >
            + Altro
          </a>
        </div>
      </div>
    </section>
  );
}